/* eslint-disable @typescript-eslint/naming-convention */
export enum TableRenderingEnum {
    Top = 'top',
    Left = 'left',
}
